import { formatDateForThreadList } from "@/components/threads/util.ts";
import { Button } from "@/components/ui/button.tsx";
import { cn } from "@/lib/utils.ts";
import type { ContactCommunicationThread } from "@/types/contactActivity.ts";
import { Mail, MessageCircle } from "lucide-react";

/** A single communication-thread row in the contact's Communications tab. */
export const ContactCommunicationRow = ({
  thread,
  onOpen,
}: {
  thread: ContactCommunicationThread;
  onOpen: (communicationId: string) => void;
}) => {
  const ChannelIcon = thread.channel === "text" ? MessageCircle : Mail;
  return (
    <Button
      variant="ghost"
      data-statsig-name="contact-communication-row"
      onClick={() => onOpen(thread.communicationId)}
      className="flex h-auto w-full items-center justify-start gap-2.5 rounded-xl px-2 py-2 text-left"
    >
      <ChannelIcon className="size-3.5 shrink-0 text-muted-foreground" />
      <div className="flex min-w-0 flex-1 flex-col">
        <span
          className={cn("flex items-center gap-1.5 truncate", thread.unread && "font-semibold")}
        >
          <span className="truncate text-sm">{thread.subject || "(no subject)"}</span>
          {thread.messageCount > 1 && (
            <span className="shrink-0 rounded-full bg-muted px-1.5 text-xs font-normal tabular-nums text-muted-foreground">
              {thread.messageCount}
            </span>
          )}
        </span>
        {thread.snippet && (
          <span className="truncate text-xs font-normal text-muted-foreground">
            {thread.snippet}
          </span>
        )}
      </div>
      <span className="shrink-0 text-xs font-normal text-muted-foreground">
        {formatDateForThreadList(new Date(thread.dateMs))}
      </span>
    </Button>
  );
};
